import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BannerList from './banner_list';
import BannerDetail from './banner_detail';

class Banners extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <BannerList/>;
    }else{
      if(params.id===undefined){
        view = <BannerDetail/>;
      }else{
        view = <BannerDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Banners.contextTypes = {
  router: PropTypes.object
};

export default Banners;
